import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/Users/gle6/dev/rambler/aqua/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray";
//
//
//
//
//
//
import Recipes from '@/data';
export default {
  name: 'recipe',
  props: {
    id: String
  },
  head: {
    meta: function meta() {
      var _this$id$split = this.id.split('-'),
          _this$id$split2 = _slicedToArray(_this$id$split, 2),
          type = _this$id$split2[0],
          num = _this$id$split2[1];

      var data = Recipes[type][parseInt(num)];
      if (!data) return;
      return [{
        property: 'og:title',
        content: data.top
      }, {
        property: 'og:description',
        content: data.bottom
      }, {
        property: 'og:image',
        content: "https://aquaminerale.eda.ru/shares/".concat(type, "/").concat(parseInt(num) + 1, ".jpg")
      }, {
        property: 'og:site_name',
        content: data.top
      }, {
        property: 'twitter:description',
        content: data.top
      }];
    }
  },
  mounted: function mounted() {
    if (this.id && window.innerWidth > 1 && window.innerHeight > 1) {
      window.location.replace('/');
    } // hack for vue-head

  }
};